import axios from "axios";
import config from "../../../config";

const baseUrl = config.baseUrl;
const endpoint = "/api/financiero/fin_entregas";

const getEntregasPO = async ({ page = 1, limit = 20, search = "" } = {}) => {
  const response = await axios.get(`${baseUrl}${endpoint}`, {
    params: { page, limit, search: search || undefined }
  });
  return response.data;
};

const getLineasActaPO = async ({ oid_participante, tipo_entrega, fecha_entrega }) => {
  const response = await axios.get(`${baseUrl}${endpoint}`, {
    params: {
      page: 1,
      limit: 100,
      oid_participante,
      tipo_entrega,
      fecha_entrega
    }
  });
  return response.data.data || [];
};

const getActasPO = async ({ page = 1, limit = 10, search = "", oid_proyecto, oid_municipio, tipo_entrega } = {}) => {
  const response = await axios.get(`${baseUrl}${endpoint}/actas`, {
    params: { page, limit, search: search || undefined, oid_proyecto, oid_municipio, tipo_entrega }
  });
  return response.data;
};

const getStatsEntregasPO = async ({ search = "", oid_proyecto, oid_municipio, tipo_entrega } = {}) => {
  const response = await axios.get(`${baseUrl}${endpoint}/stats`, {
    params: { search: search || undefined, oid_proyecto, oid_municipio, tipo_entrega }
  });
  return response.data;
};

const createEntregaPO = async (data, usuario = "system") => {
  const response = await axios.post(`${baseUrl}${endpoint}`, data, {
    headers: { usuario }
  });
  return response.data;
};

// Guarda el acta completa (encabezado + líneas) en una sola transacción; el
// backend valida stock y pertenencia al proyecto.
const createActaPO = async (payload, usuario = "system") => {
  const response = await axios.post(`${baseUrl}${endpoint}/acta`, payload, {
    headers: { usuario }
  });
  return response.data;
};

// Guarda vereda y objetivo en un acta que aún no los tiene.
const completarDatosActaPO = async (data, usuario = "system") => {
  const response = await axios.put(`${baseUrl}${endpoint}/acta/datos`, data, {
    headers: { usuario }
  });
  return response.data;
};

const updateEntregaPO = async (id, data, usuario = "system") => {
  const response = await axios.put(`${baseUrl}${endpoint}/${id}`, data, {
    headers: { usuario }
  });
  return response.data;
};

const deleteEntregaPO = async (id, usuario = "system") => {
  const response = await axios.delete(`${baseUrl}${endpoint}/${id}`, {
    headers: { usuario }
  });
  return response.data;
};

const getStockProductoPO = async (id) => {
  const response = await axios.get(`${baseUrl}/api/financiero/fin_entregas/stock/${id}`);
  return response.data;
};

export {
  getEntregasPO,
  getLineasActaPO,
  getActasPO,
  getStatsEntregasPO,
  createEntregaPO,
  createActaPO,
  completarDatosActaPO,
  updateEntregaPO,
  deleteEntregaPO,
  getStockProductoPO
};
